/**
 * Aviso de escritorio para cambios en Customer / Journey Experience vía Socket.IO (journey_updated).
 * La UI que refresca listas vive en páginas concretas; esto asegura el globo del SO en toda la app.
 */
import { useCallback } from 'react';
import { useRealtimeOn } from '../context/RealtimeSocketContext';
import Swal from 'sweetalert2';

export default function JourneyDesktopNotify() {
  const onUpdate = useCallback((payload) => {
    const { journey_id, action, updated_count } = payload || {};

    // Solo mostrar toast para acciones que no tienen modal propio y son relevantes al instante
    const SHOW_ONLY = ['deleted', 'phases_synced'];
    if (!SHOW_ONLY.includes(action)) return;

    let title = 'Customer Journey';
    let body = 'Hubo cambios en un journey.';

    if (action === 'created') {
      title = 'Nuevo journey';
      body =
        journey_id != null ? `Se creó el journey #${journey_id}.` : 'Se creó un journey en el sistema.';
    } else if (action === 'updated') {
      title = 'Journey actualizado';
      body =
        journey_id != null ? `Se actualizó el journey #${journey_id}.` : 'Se actualizó un journey.';
    } else if (action === 'deleted') {
      title = 'Journey eliminado';
      body =
        journey_id != null ? `Se eliminó el journey #${journey_id}.` : 'Se eliminó un journey.';
    } else if (action === 'event_created') {
      title = 'Nuevo evento';
      body =
        journey_id != null
          ? `Journey #${journey_id} con nuevo evento.`
          : 'Se registró un nuevo evento.';
    } else if (action === 'phases_synced') {
      title = 'Journeys: fases sincronizadas';
      body =
        updated_count != null
          ? `Sincronización completada (${updated_count} ítem(s)).`
          : 'Sincronización de fases completada.';
    }

    const toneClass =
      action === 'deleted'
        ? 'journey-notify-toast--warning'
        : action === 'updated'
          ? 'journey-notify-toast--info'
          : 'journey-notify-toast--success';

    const glyph =
      action === 'deleted' ? 'bi-exclamation-triangle-fill' : action === 'updated' ? 'bi-arrow-repeat' : 'bi-check-circle-fill';

    Swal.fire({
      toast: true,
      position: 'top-end',
      html: `
        <div class="journey-notify-toast-content ${toneClass}">
          <div class="journey-notify-toast-icon">
            <i class="bi ${glyph}" aria-hidden="true"></i>
          </div>
          <div class="journey-notify-toast-text">
            <div class="journey-notify-toast-title">${title}</div>
            <div class="journey-notify-toast-message">${body}</div>
          </div>
        </div>
      `,
      showConfirmButton: false,
      timer: 20000,
      timerProgressBar: true,
      width: 360,
      customClass: {
        popup: 'swal2-popup-compact journey-notify-toast',
        htmlContainer: 'journey-notify-toast-body',
        timerProgressBar: 'journey-notify-toast-progress',
      },
      didOpen: (popup) => {
        popup.style.width = '360px';
        popup.style.maxWidth = 'calc(100vw - 1rem)';
      },
    });
  }, []);

  useRealtimeOn('journey_updated', onUpdate);

  return null;
}
